import type { LayoutFieldType } from "@whatslly/types/LayoutFieldType";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import { CheckBox } from "@whatslly/ui-components/v2/BaseElements/CheckBox";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import classnames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./FieldRow.module.scss";

export const FieldRow: React.FC<{
  field: LayoutFieldType;
  onDeleteItem: (field: LayoutFieldType) => void;
  onUpdateRequired: (field: LayoutFieldType) => void;
  onEditItem: (field: LayoutFieldType) => void;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
  showRequiredCheckbox: boolean;
}> = ({ field, onDeleteItem, showRequiredCheckbox, onUpdateRequired, onEditItem, showEditButton, showDeleteButton }) => {
  const { t } = useTranslation();

  return (
    <Tooltip value={t("editLayouts.mandatory_field")} disabled={field.d}>
      <div className={classnames(styles.fieldInputContainer, { [styles.notDeleteAble]: !field.d })}>
        <div className={styles.checkboxAndTitleContainer}>
          {showRequiredCheckbox && (
            <Tooltip className={styles.alwaysRequireTooltip} value={t("editLayouts.always_require_a_value")} disabled={!field.d}>
              <div className={styles.fieldCheckBoxContainer}>
                <CheckBox
                  onChange={() => onUpdateRequired(field)}
                  checked={field.r}
                  disabled={!field.d}
                  className={classnames(styles.checkBox, {
                    [styles.required]: field.r,
                  })}
                  clickAbleLabel
                  checkBoxTextGap={17}
                />
              </div>
            </Tooltip>
          )}
          <div className={classnames(styles.fieldInput)}>{field.l}</div>
        </div>
        <div className={styles.rightSide}>
          {showEditButton && (
            <div className={styles.editButton} onClick={() => onEditItem(field)}>
              Edit
            </div>
          )}
          {showDeleteButton && field.d && (
            <div onClick={() => onDeleteItem(field)} className={styles.removeFieldContainer} data-testid="remove-field-button">
              <Svg className={styles.removeFieldIcon} iconName={"close"} width={12} height={12} />
            </div>
          )}
        </div>
      </div>
    </Tooltip>
  );
};
